import {
  HomeRounded, ExploreRounded, FiberNewRounded, StarBorderRounded,
  DashboardRounded, GroupsRounded, PeopleRounded, FactCheckRounded,
  SettingsRounded, CategoryRounded,
  LocationOn, AccountTreeRounded,
} from '@mui/icons-material';

const allNavItems = [
  {
    path: '/dashboard',
    label: 'Dashboard',
    icon: DashboardRounded,
    navKey: 'nav.dashboard',
    menuKey: 'menu.dashboard',
    fallback: 'Dashboard',
    section: 'private'
  },
  {
    path: '/',
    label: 'Home',
    icon: HomeRounded,
    navKey: 'nav.home',
    menuKey: 'menu.home',
    fallback: 'Home',
    section: 'private'
  },
  {
    path: '/products',
    label: 'Products',
    icon: CategoryRounded,
    navKey: 'nav.products',
    menuKey: 'menu.products',
    fallback: 'Products',
    section: 'private',
    children: [
      {
        path: '/explore-all',
        label: 'Explore All',
        icon: ExploreRounded,
        navKey: 'nav.explore-all',
        menuKey: 'menu.exploreProducts',
        fallback: 'Explore All',
        section: 'both'
      },
      {
        path: '/new-arrivals',
        label: 'New Arrivals',
        icon: FiberNewRounded,
        navKey: 'nav.new-arrivals',
        menuKey: 'menu.newArrivals',
        fallback: 'New Arrivals',
        section: 'both'
      },
      {
        path: '/featured-products',
        label: 'Featured Products',
        icon: StarBorderRounded,
        navKey: 'nav.featured-products',
        menuKey: 'menu.featuredProducts',
        fallback: 'Featured Products',
        section: 'both'
      },
    ]
  },
  // {
  //   path: '/test',
  //   label: 'Test',
  //   icon: GroupsRounded,
  //   navKey: 'menu.test',
  //   menuKey: 'menu.test',
  //   fallback: 'Test',
  //   section: 'private'
  // },
  {
    path: '/profile',
    label: 'My Profile',
    icon: PeopleRounded,
    navKey: 'menu.myProfile',
    menuKey: 'menu.myProfile',
    fallback: 'My Profile',
    section: 'private'
  },
  {
    path: '/shipping',
    label: 'Shipping',
    icon: LocationOn,
    navKey: 'menu.shipping',
    menuKey: 'menu.shipping',
    fallback: 'Shipping',
    section: 'private'
  },
  {
    path: '/orders',
    label: 'My Orders',
    icon: FactCheckRounded,
    navKey: 'menu.myOrders',
    menuKey: 'menu.myOrders',
    fallback: 'My Orders',
    section: 'private'
  },
  {
    path: '/descendant-list',
    label: 'Descendant List',
    icon: AccountTreeRounded,
    navKey: 'menu.descendantList',
    menuKey: 'menu.descendantList',
    fallback: 'Descendant List',
    section: 'private'
  },
];

const secondaryNavItems = [
  { path: '/settings', label: 'Settings', icon: SettingsRounded, navKey: 'menu.settings', menuKey: 'menu.settings', fallback: 'Settings' },
];

const flattenChildren = (items) =>
  items.reduce((acc, item) => {
    if (item.children) acc.push(...item.children);
    return acc;
  }, []);

export const desktopNavItems = [
  ...allNavItems.filter(item => item.section === 'public' || item.section === 'both'),
  ...flattenChildren(allNavItems).filter(item => item.section === 'public' || item.section === 'both'),
]
  .map(({ path, label, navKey, fallback }) => ({ path, label, labelKey: navKey, fallback }));

export const mobileNavItems = [
  ...allNavItems.filter(item => item.path === '/'),
  ...allNavItems.filter(item => item.section === 'public' || item.section === 'both'),
  ...flattenChildren(allNavItems).filter(item => item.section === 'public' || item.section === 'both'),
  ...allNavItems.filter(item => item.path === '/dashboard'),
]
  .filter(item => ['/', '/explore-all', '/new-arrivals', '/featured-products', '/dashboard'].includes(item.path))
  .map(({ icon, path, navKey, fallback }) => ({ icon, path, labelKey: navKey, fallback }));

export const sidebarNavItems = allNavItems
  .filter(item => item.section === 'private' || item.section === 'both')
  .map(({ icon, path, menuKey, children }) => ({
    menu: menuKey,
    icon,
    route: path,
    ...(children && {
      children: children.map(({ icon: childIcon, path: childPath, menuKey: childMenuKey }) => ({
        menu: childMenuKey,
        icon: childIcon,
        route: childPath,
      }))
    })
  }));

export const sidebarSecondaryItems = secondaryNavItems
  .map(({ icon, path, menuKey }) => ({ menu: menuKey, icon, route: path }));
